import TextWithImageCarousel, { TextWithImageCarouselProps, NAVIGATION_TYPE } from './TextWithImageCarousel'

export default TextWithImageCarousel

export { TextWithImageCarouselProps, TextWithImageCarousel, NAVIGATION_TYPE }
